<div class="main-container learnspace-theme">
  <div class="header-container">
    <div class="header responsive-container">
      <program-list-item *ngIf="program"
        class="compact"
        [title]="template.title"
        [description]="template.description"
        [tags]="template.tags"
        [poster]="template.thumbnail"
        [experienceCount]="program.courses.length"
        [clickDeactived]="true"
        [actionButtons]="actionButtons"
      ></program-list-item>
      <mat-icon fontSet="fa" fontIcon="fa-close" class="large-close-icon" [mat-dialog-close]></mat-icon>
    </div>
  </div>

  <div class="list responsive-container">
    <div class="title programs-h5">Program Simulations</div>
    <simulation-list-item *ngFor="let course of program?.courses"
      [course]="course"
      [simplifiedMode]="true"
    ></simulation-list-item>
  </div>
</div>